<template>
  <div class="list--wrap">
    <table class="ab__list__table">
      <caption hidden>A/B Test List</caption>
      <colgroup>
        <col width="*">
        <col width="80px">
        <col width="121px">
        <col width="107px">
        <col width="120px">
        <col width="116px">
        <col width="60px">
      </colgroup>
      <thead>
        <tr>
          <th>
            <sort-options
              columnName="pageName"
              :sortColumn="sortColumn"
              :isSortAsc="isSortAsc"
              @onSortOptionChange="onSortOptionChange">
              <span v-html="$t('common.table.header.test')"></span>
            </sort-options>
          </th>
          <th>
            <span v-html="$t('common.table.header.setting')"></span>
          </th>
          <th>
            <sort-options
              columnName="status"
              :sortColumn="sortColumn"
              :isSortAsc="isSortAsc"
              @onSortOptionChange="onSortOptionChange">
              <span v-html="$t('common.table.header.status')"></span>
            </sort-options>
          </th>
          <th>
            <span v-html="$t('common.table.header.trackingCode')"></span>
          </th>
          <th>
            <sort-options
              columnName="startDate"
              :sortColumn="sortColumn"
              :isSortAsc="isSortAsc"
              @onSortOptionChange="onSortOptionChange">
              <span v-html="$t('common.table.header.createdAt')"></span>
            </sort-options>
          </th>
          <th>
            <span v-html="$t('common.table.header.report')"></span>
          </th>
          <th>
          </th>
        </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in sortedList" :key="index">
        <td :disabled="item.status === 'error' || item.status === 'deleted'"
            :class="{disabled: item.status === 'error' || item.status === 'deleted'}"
            @click="onMoveABreport(item)"
            class="col__name align-left">
          <p class="page-name">{{ item.pageName }}</p>
          <p class="page-url">{{ item.url }}</p>
        </td>

        <td class="col__setting">
          <button :class="{disabled: isShared}" @click.stop="showSettingOption($event)" class="icon icon--dashboard-setting"></button>
          <div class="setting__option--wrap" style="display: none">
            <ul>
              <li @click="onModifyStatus(item, 'run')" v-if="item.status === 'stop'">
                {{ $t('ab.changeState.run') }}
              </li>
              <li @click="onModifyStatus(item, 'stop')" v-if="item.status === 'run'">
                {{ $t('ab.state.stop') }}
              </li>
              <li @click="onMoveEditPage(item)">
                {{ $t('ab.changeSetting') }}
              </li>
            </ul>
          </div>
        </td>

        <td class="col__status" :class="item.status">
              <span class="status-error"
                    v-if="item.status === 'uninstalled' || item.status === 'error' || item.status === 'deleted'">
                {{ $t(`ab.state.${item.status}`) }}
                <ui-icon-tooltip arrowCenter>
                  <i class="icon icon--alert-triangle-size16"></i>
                  <span v-html="$t('common.trackingCode.required')"></span>
                </ui-icon-tooltip>
              </span>
          <span v-else>{{ $t(`ab.state.${item.status}`) }}</span>
        </td>

        <td class="col__tracking-code">
          <button @click="onCheckInstall(item)"
                  class="btn__check-code"
                  v-if="item.status === 'uninstalled' || item.status === 'error' || item.status === 'deleted'">
            {{ $t('common.trackingCode.checkInstall') }}
          </button>
          <i class="icon icon--check-green-size16" v-else></i>
        </td>

        <td class="col__regi-date">
          <span v-if="item.startDate">{{ item.startDate | dashDate }}</span>
          <span v-else>{{ item.regDate | dashDate }}</span>
        </td>

        <td class="col__confirm">
          <button @click="onMoveABreport(item)"
                  :disabled="item.status === 'error' || item.status === 'deleted'"
                  :class="{disabled: item.status === 'error' || item.status === 'deleted'}">
            <i class="icon icon--arrow-green-size16"></i>
            <span class="btn-text">{{ $t('common.view') }}</span>
          </button>
        </td>

        <td class="col__delete">
          <button v-if="!isShared" @click="onDeleteConfirm(item)" class="icon icon--trash"></button>
        </td>
      </tr>
      </tbody>
    </table>

    <install-checker v-if="installCheckerData"
      :checkerData="installCheckerData"
      @onDone="onInstallCheckDone"/>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { modifyPage, deletePage } from '@/api/abtest'
import { create } from 'vue-modal-dialogs'
import { cloneDeep } from '@/libs/utils'
import AppDialog from '@/components/ui/AppDialog'
import InstallChecker from '@/components/ui/InstallChecker'
import UiIconTooltip from '@/components/ui/UiIconTooltip'
import SortOptions from '@/components/ui/SortOptions'

const confirmDelete = create(AppDialog, 'customData')

export default {
  components: {
    InstallChecker,
    UiIconTooltip,
    SortOptions
  },
  data () {
    return {
      sortColumn: 'pageName',
      isSortAsc: true,
      installCheckerData: null
    }
  },
  props: [
    'abPageList'
  ],
  computed: {
    ...mapState([
      'applyData'
    ]),
    sortedList () {
      const list = cloneDeep(this.abPageList)
      return list.sort((a, b) => {
        const modifier = this.isSortAsc ? 1 : -1
        if (a[this.sortColumn] < b[this.sortColumn]) return -1 * modifier
        if (a[this.sortColumn] > b[this.sortColumn]) return 1 * modifier
        return 0
      })
    },
    aid () {
      return this.$route.params.aid
    },
    isShared () {
      return this.applyData.meta.shared
    }
  },
  methods: {
    ...mapActions([
      'storeABList'
    ]),
    showSettingOption () {
      if (this.isShared) return false
      this.hideSettingOption()
      event.target.nextSibling.style.display = 'inline-block'
    },
    hideSettingOption () {
      const settingOptionEl = document.querySelectorAll('.col__setting .setting__option--wrap')
      for (const item of settingOptionEl) {
        item.style.display = 'none'
      }
    },
    onCheckInstall (item) {
      this.installCheckerData = {
        type: 'ab',
        aid: item.aid,
        url: item.url
      }
    },
    onModifyStatus (item, status) {
      const values = {
        orgAid: this.applyData._id,
        abAid: item.aid,
        pageName: item.pageName,
        status: status
      }

      modifyPage(values).then(res => {
        return this.storeABList(this.aid)
      }).catch(console.error)
    },
    onDeleteConfirm (item) {
      if (this.isShared) return false
      confirmDelete({
        type: 'confirm',
        iconClass: 'icon--dialog-trash',
        title: this.$t('dialog.abDelete.title'),
        description: this.$t('dialog.abDelete.desc', { pageName: item.pageName })
      }).then(result => {
        if (result) {
          const values = { orgAid: this.applyData._id, abAid: item.aid }
          deletePage(values)
            .then(() => {
              return this.storeABList(this.aid)
            })
            .catch(console.error)
        }
      })
    },
    onMoveEditPage (item) {
      this.hideSettingOption()
      this.$router.push({
        name: 'ab.edit',
        params: { aid: this.aid, abAid: item.aid }
      })
    },
    onMoveABreport (item) {
      if (item.status === 'error' || item.status === 'deleted') {
        return false
      }
      this.$router.push({
        name: 'ab.view',
        params: { aid: this.aid, abAid: item.aid }
      })
    },
    onSortOptionChange (column, isAsc) {
      if (this.sortColumn === column && this.isSortAsc === isAsc) {
        return
      }
      this.sortColumn = column
      this.isSortAsc = isAsc
    },
    onInstallCheckDone (needReload) {
      this.installCheckerData = null

      if (needReload) {
        this.storeABList(this.aid).catch(console.error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.list--wrap {
  .ab__list__table {
    margin-top: 20px;
    width: 100%;
    font-size: 13px;
    thead tr {
      height: 50px;
      background-color: #555555;
      font-weight: bold;
      line-height: 1.23;
      color: #ffffff;
      text-align: center;

      th.clickable { cursor: pointer; }

      th:nth-of-type(1){
        position: relative;
        &:before {
          content: '';
          display: inline-block;
          width: 15px;
          height: 50px;
          position: absolute;
          top: 0;
          left: -5px;
          background-color: #555;
          border-radius: 5px;
        }
        &.align-left {
          text-align: left;
          padding-left: 10px;
        }
      }
      th:nth-last-of-type(1) {
        position: relative;
        &:after {
          content: '';
          display: inline-block;
          width: 10px;
          height: 50px;
          position: absolute;
          top: 0;
          right: -5px;
          background-color: #555;
          border-radius: 5px;
        }
      }

      span {
        position: relative;
        display: inline-block;
        .icon {
          position: absolute;
          top: 50%;
          right: -19px;
          transform: translateY(-50%);
        }
      }
    }
    tbody tr {
      height: 80px;
      text-align: center;
      border-top: 1px solid #ebebeb;
      box-sizing: border-box;

      &:nth-of-type(1) {
        border-top: none;
      }

      &:nth-last-of-type(1) {
        border-bottom: 1px solid #ebebeb;
      }

      &:hover {
        @include hoverStyle;
      }

      td {
        font-size: 13px;
        color: #666;

        &.align-left {
          padding-left: 10px;
          text-align: left;
        }

        &.col__name {
          line-height: 1.4;

          &:hover:not(.disabled) {
            cursor: pointer;
            .page-name {
              color: #1199af !important;
            }
          }
          .page-name {
            font-size: 14px;
            font-weight: bold;
            color: #2f2f2f;
            @include textEllipsis;
          }
          .page-url {
            margin-top: 15px;
            @include textEllipsis;
          }
        }

        &.col__setting {
          position: relative;
          button {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            background-position: center;

            &:hover {
              @include hoverStyle;
            }

            &.disabled {
              pointer-events: none;
              opacity: 0.2;
            }
          }
          .setting__option--wrap {
            position: absolute;
            top: 60px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 1;
            ul {
              width: 75px;
              border-radius: 6px;
              box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.25);
              background-color: #ffffff;
              overflow: hidden;

              li {
                cursor: pointer;
                height: 37px;
                line-height: 35px;
                font-size: 14px;
                color: #444444;

                &:hover {
                  background-color: #ebebeb;
                }
              }
            }
          }
        }

        &.col__status {
          &.run { color: $stateRunColor; }
          &.stop { color: $stateStopColor; }
          &.deleted { color: $stateUnInstalledColor; }
          &.uninstalled { color: $stateUnInstalledColor; }
          &.error { color: $stateUnInstalledColor; }

          .status-error {
            position: relative;

            /deep/ .tooltip {
              .icon {
                width: 16px;
                height: 16px;
                background-image: url(../../assets/img/icon_alert_triangle_size16.svg);
              }
              .text {
                .icon {
                  margin-right: 5px;
                  position: relative;
                  top: 2px;
                }
              }
            }
          }
        }

        &.col__confirm {
          button {
            @include buttonSizeSmall_includeIcon;
            border: 1px solid #57ab00;
            background-color: #fff;

            &:hover {
              &:after {
                @include hoverStyle;
              }
            }

            &.disabled {
              opacity: 0.3;
            }

            .btn-text{
              color: #57ab00;
            }
          }
        }

        &.col__tracking-code {
          .btn__check-code {
            @include buttonTypeSmall;
            border: solid 1px #bbbbbb;
            background-color: #ffffff;
            font-size: 13px;
            font-weight: bold;
            color: #444444;

            &:hover {
              @include hoverStyle;
            }
          }
        }

        &.col__delete {
          button {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            background-position: center;

            &:hover {
              @include hoverStyle;
            }

            &.disabled {
              pointer-events: none;
              opacity: 0.2;
            }
          }
        }
      }
    }
  }
}
</style>
